export const ALLOWANCE_GET = "ALLOWANCE_GET";
